import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {
  ContractService,
  RegistrationEntry,
} from '@app/core/services/contract/contract.service'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '@app/core/services/generic-list.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

@Injectable()
export class RegistrationEntryListService extends GenericListService<RegistrationEntry> {
  domain: string
  id: number

  constructor(
    private contractSvc: ContractService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<RegistrationEntry>> {
    return this.contractSvc.getRegistrationEntries(this.domain, this.id).pipe(
      map((res) => {
        const result: LoadResult<RegistrationEntry> = {
          total: res.length,
          items: res.slice(request.offset, request.offset + request.count),
        }
        return result
      }),
    )
  }
}
